/* eslint-disable @typescript-eslint/no-explicit-any */
// Used by External library ag-Grid
import { Directive, Output, EventEmitter, HostBinding, HostListener } from '@angular/core';

@Directive({
    standalone: false,
    selector: '[porAppDnd]'
})
export class PorDndDirective {
    @HostBinding('class.fileover') fileOver!: boolean;
    @Output() readonly fileDropped = new EventEmitter<any>();

    // Dragover listener
    @HostListener('dragover', ['$event']) onDragOver(evt: any) {
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOver = true;
    }

    // Dragleave listener
    @HostListener('dragleave', ['$event']) public onDragLeave(evt: any) {
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOver = false;
    }

    // Drop listener
    @HostListener('drop', ['$event']) public ondrop(evt: any) {
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOver = false;
        const files = evt.dataTransfer.files;
        if (files.length > 0) {
            this.fileDropped.emit(files);
        }
    }
}
